/**
 * Query Keys to persist and where to persist them.
 */
export const QUERY_STORAGE_KEYS: Array<{key: string[], storage: 'localStorage' | 'sessionStorage', persistOnLogout?: boolean}> = [
    { key: ['accountGetAccountsByCurrentUser'], storage: 'localStorage' },
    { key: ['accountGetAccount'], storage: 'localStorage' },
    { key: ['accountGetAccountContacts'], storage: 'localStorage' },
    { key: ['accountGetAccountPropertiesContacts'], storage: 'localStorage' },
    { key: ['publicGetHelpTexts'], storage: 'localStorage', persistOnLogout: true },
    { key: ['publicGetPrivacyPolicy'], storage: 'localStorage', persistOnLogout: true },
    { key: ['userGetLoggedInUser'], storage: 'sessionStorage' },
]